import React from 'react';

const DownArrow: React.SFC = (props) => (
  <svg fill="currentColor" width="22px" height="13px" viewBox="0 0 22 13" version="1.1" {...props}>
    <g id="UI" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="📱UI-MICRO-FULL" transform="translate(-177.000000, -572.000000)" stroke="currentColor" strokeWidth="2">
            <g id="scroll" transform="translate(88.000000, 545.000000)">
                <polyline id="Rectangle" transform="translate(100.000000, 28.000000) rotate(-315.000000) translate(-100.000000, -28.000000) " points="107 21 107 35 93 35"></polyline>
            </g>
        </g>
    </g>
</svg>
);

export default DownArrow;